import useProductBaseActions from './useProductBaseActions'

export default useProductBaseActions
